import React, {
  useState,
  useEffect,
  createContext,
  PropsWithChildren,
  useContext,
} from "react";
import { io } from "socket.io-client";
import { Outlet } from "react-router-dom";

import { useGetChatAuthTokenMutation } from "src/store/chat/api";
import { CHAT_WEB_SOCKET_URL } from "src/constants";

type ChatSocketConnection =
  { chatSocket: undefined | ReturnType<typeof io> | null; connecting: boolean} |
  null |
  undefined;

export const ChatSocketIoContext = createContext<ChatSocketConnection>(undefined);

export const ChatWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const chatSocketContextCurrent = useContext(ChatSocketIoContext);
  const [chatSocketConnection, setChatSocketConnection] = useState<ChatSocketConnection>(chatSocketContextCurrent);
  const [getChatAuthToken, { data: chatAuthOption, isLoading, isError }] = useGetChatAuthTokenMutation();

  useEffect(
    () => {
      if (chatSocketContextCurrent === undefined) {
        getChatAuthToken();
      }
      setChatSocketConnection({ chatSocket: null, connecting: true });
      return () => {
        if (chatSocketContextCurrent === undefined) {
          chatSocketConnection?.chatSocket?.disconnect();
        }
      };
    },
    [chatSocketContextCurrent]
  );


  useEffect(() => {
    if (!isLoading && !isError && chatAuthOption && CHAT_WEB_SOCKET_URL) {
      localStorage.setItem("chat-token", chatAuthOption.token);
      const chatSocket = io(CHAT_WEB_SOCKET_URL, { auth: chatAuthOption, transports: ["websocket", "polling"] });
      chatSocket.on("connect", () => setChatSocketConnection({ chatSocket, connecting: false }));
    }
  }, [isLoading]);


  return (
    <ChatSocketIoContext.Provider value={chatSocketConnection}>
      {children || <Outlet />}
    </ChatSocketIoContext.Provider>
  );
};
